export enum BookingWindowStatus {
  DRAFT = "draft",
  OPEN = "open",
  PACKAGING = "packaging",
  PRESENTATION = "presentation",
  CLOSED = "closed",
  ARCHIVED = "archived"
}

export interface BookingWindow {
  id: string;
  name: string;
  slug: string;
  status: BookingWindowStatus;
  submission_start_date: string;
  submission_end_date: string;
  packaging_start_date?: string;
  packaging_end_date?: string;
  presentation_date?: string;
  created_at: string;
  updated_at: string;
  created_by?: string;
  eligible_project_count: number;
  campaign_count: number;
  total_budget_submitted: number;
}

export interface BookingWindowCreate {
  name: string;
  slug: string;
  status: BookingWindowStatus;
  submission_start_date: string;
  submission_end_date: string;
  packaging_start_date: string;
  packaging_end_date: string;
  presentation_date: string;
}

export interface BookingWindowUpdate {
  name?: string;
  slug?: string;
  status?: BookingWindowStatus;
  submission_start_date?: string;
  submission_end_date?: string;
  packaging_start_date?: string;
  packaging_end_date?: string;
  presentation_date?: string;
}

export interface BookingWindowSummary {
  id: string;
  name: string;
  slug: string;
  status: BookingWindowStatus;
  submission_start_date: string;
  submission_end_date: string;
  packaging_start_date?: string;
  packaging_end_date?: string;
  presentation_date?: string;
  eligible_project_count?: number;
  campaign_count: number;
  total_budget_submitted: number;
  is_active: boolean;
}
